import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './EC2LoadingBar.css';
import { baseApi } from '../../../../API/api';

const EC2LoadingBar = ({ projectId, onComplete, onError, onStopping }) => {
  const [currentStep, setCurrentStep] = useState('checking');
  const [statusMessage, setStatusMessage] = useState('Checking instance status...');

  const steps = [
    { key: 'checking', label: 'Checking instance status...', duration: 10, progress: 5 },
    { key: 'starting', label: 'Starting EC2 instance...', duration: 60, progress: 20 },
    { key: 'booting', label: 'Instance booting up...', duration: 120, progress: 40 },
    { key: 'health_check', label: 'Running health checks...', duration: 60, progress: 60 },
    { key: 'js_server', label: 'Starting JS server...', duration: 120, progress: 90 },
    { key: 'OK', label: 'Almost ready...', duration: 10, progress: 100 }
  ];

  useEffect(() => {
    startInstanceStartup();
  }, []);


  const startInstanceStartup = async () => {
    try {
      setStatusMessage('Initializing...');
      setCurrentStep('checking');
      
      // Check if instance is already running and healthy
      let status;
      try {
        const statusResponse = await axios.get(`${baseApi}/api/ec2/check-ready/${projectId}`);
        status = statusResponse.data;
      } catch (statusError) {
        console.warn('EC2 status check returned an error status:', statusError);
        status = statusError.response?.data || { success: false, error: statusError.message };
      }
      
      status = status || {};

      if (status.success && status.ready_for_streaming) {
        setStatusMessage('Instance is ready!');
        setCurrentStep('OK');
        setTimeout(() => {
          onComplete();
        }, 1000);
        return;
      }
      
      // Start the instance startup process
      setStatusMessage('Starting EC2 instance...');
      setCurrentStep('starting');
      
      const startResponse = await axios.post(`${baseApi}/api/ec2/start/${projectId}`);
      const startResult = startResponse.data;
      
      if (startResult.success) {
        setStatusMessage('Instance started successfully!');
        setCurrentStep('OK');
        setTimeout(() => {
          onComplete();
        }, 1000);
      } else {
        // Check if instance is in stopping state
        if (startResult.error === 'Instance is shutting down') {
          setStatusMessage(`Instance is shutting down. Please wait ${startResult.retry_after_minutes || 3} minutes and try again.`);
          setCurrentStep('stopping');
          // Hide loading bar after showing the message for a few seconds
          setTimeout(() => {
            // Call onStopping callback to hide loading bar without showing error alert
            if (onStopping) {
              onStopping();
            } else {
              // Fallback to onError if onStopping not provided
              onError(new Error('Instance is shutting down'));
            }
          }, 5000);
        } else {
          throw new Error(startResult.message || startResult.error || 'Failed to start instance');
        }
      }
      
    } catch (error) {
      console.error('Error starting instance:', error);
      const responseData = error.response?.data;
      const errorDetails = responseData?.message || responseData?.error;
      const errorMessage = errorDetails || error.message || 'Unknown error occurred while starting instance';
      setStatusMessage(`Error: ${errorMessage}`);
      onError(new Error(errorMessage));
    }
  };


  return (
    <div className={`ec2-loading-bar ${currentStep === 'stopping' ? 'stopping' : ''}`}>
      <div className="ec2-loading-content">
        <div className="ec2-loading-left">
          <div className="ec2-loading-spinner">
            <div className="spinner-circle"></div>
          </div>
          <span className="ec2-status-text">{statusMessage}</span>
        </div>
        
      </div>
    </div>
  );
};

export default EC2LoadingBar;
